module.exports = "/images/lc-logo.png?5af5c99757415a8cbe47b6aa1ec62c7a";